<template>
    <div>
        <!-- 题库练习最后结果页 -->
         <div class="answer-result-tip">你已做完最后一题</div>
         <div class="answer-result-subtip">恭喜您完成练习</div>   
         <!-- 题数 -->
         <div class="answer-result-content">
              <div class="answer-result-box">
                  <div class="answer-result-box1">{{!saveSucessTopic?'0':saveSucessTopic}}</div>
                  <div class="answer-result-box2">做对题数</div>
              </div>
               <div class="answer-result-box">
                  <div class="answer-result-box1">{{!saveFailTopic?'0':saveFailTopic}}</div>
                  <div class="answer-result-box2">做对题数</div>
              </div>
               <div class="answer-result-box">
                  <div class="answer-result-box1">0</div>
                  <div class="answer-result-box2">做对题数</div>
              </div>
         </div>
               <div class='btn'  @click="handleGoPagepAssess">返回人员考核</div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            saveSucessTopic:'',
            saveFailTopic:''
        }
    },
    mounted() {
       this.saveSucessTopic =  sessionStorage.getItem('saveSucessTopic')
       this.saveFailTopic = sessionStorage.getItem('saveFailTopic')
    },

    beforeDestroy() {
         sessionStorage.removeItem('saveSucessTopic')
         sessionStorage.removeItem('saveFailTopic')
    },
    methods: {
    // 添加考试记录
    //点击返回人员考核 
    handleGoPagepAssess() {
        this.$router.push({
            path:'/personnelassess'
        })
    }
}
 
}
</script>

<style scoped lang="scss">
    .answer-result-tip {
        width: 100%;
        height: 55px;
        line-height: 55px;
        font-size: 21px;
        color: #333333;
        font-weight: bold;
        text-align: left;
        padding: 0 13px;
        box-sizing: border-box;
    }
    .answer-result-subtip {
        font-size: 15px;
        color: #999999;
        padding: 0 13px;
        box-sizing: border-box;
        text-align: left
    }
    .answer-result-content {
        display: flex;
        justify-content: space-around;
        margin-top: 50px;
        .answer-result-box {
            .answer-result-box1 {
                font-size: 22px;
                color: #333333;
            }
            .answer-result-box2 {
                font-size: 13px;
                color: #999999;
                margin-top: 20px;
            }
        }
    }

    .btn {
  width: 350px;
  height: 44px;
  background: -webkit-linear-gradient(left, #4badf5, #398df7);
  margin: 0 auto;
  border-radius: 22px;
  font-size: 16px;
  color: $white-color;
  line-height: 44px;
  margin-top: 50px;
  text-align: center;
}
</style>
